<template>
  <div class="public-content product-category">
    <div class="region-title" style="background: #fff" @click="asd">
      <div>自定义分类</div>
      <el-col :span="6" class="fn-right form-btn">
        <el-button class="search-ok" @click="parentDetail = '', categoryVo.level = 1, categoryVo.parentId = 0, addDialog = true" round>添加一级类</el-button>
      </el-col>
    </div>
    <div class="data-list">
      <el-table :data="tableData" ref="table" style="width: 100%;margin-bottom: 20px;" row-key="id" border lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'isHaveSub' }"
        :row-class-name="rowClassName">
        <el-table-column width="200px" prop="id" label="编号"></el-table-column>
        <el-table-column min-width="200px" prop="categoryName" label="名称">
          <template slot-scope="scope">
            <div :style="'padding-left: ' + scope.row.level * 30 + 'px;'" style="box-sizing:border-box;width:100%;text-align:left">{{ scope.row.categoryName }}</div>
          </template>
        </el-table-column>
        <el-table-column min-width="200px" prop="categoryName" label="操作">
          <template slot-scope="scope">
            <span @click="onEditClassification(scope.row)" v-if="scope.row.level !== undefined && $hasPermission('pms:admin:category:update')" class="color-blue">编辑<br></span>
            <span @click="parentDetail = scope.row.categoryName, categoryVo.level = scope.row.level ? scope.row.level + 1 : 1, categoryVo.parentId = scope.row.id, addDialog = true"
              v-if="scope.row.level !== 3 && $hasPermission('pms:admin:category:add')" class="color-blue">添加下级</span>
            <span @click="$refs.addProductDialogRef.show(scope.row.id)" v-if="!scope.row.isHaveSub && $hasPermission('pms:admin:category:add')" class="color-blue"> 关联产品 </span>
            <br>
            <span @click="customCategorySetRecommend(scope.row)" v-if="scope.row.level !== undefined && scope.row.level > 1" class="color-blue">设为推荐<br></span>
            <span @click="deleteItem = scope.row, deleteDialog = true" v-if="scope.row.level !== undefined && $hasPermission('pms:admin:category:delete')" class="color-blue">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    分页-->
    <!-- <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="tableData.length > 0" @changePage="changePage"></v-pagination> -->
    <!-- 添加下级 -->
    <el-dialog :close-on-click-modal="false" :title="categoryVo.level != 1 ? '添加下级' : '添加一级类'" :visible.sync="addDialog" @closed="$refs.add.resetFields()" width="30%">
      <el-form :model="categoryVo" :rules="rules" ref="add" label-width="140px">
        <el-form-item label="上级分类：" v-if="categoryVo.level != 1">{{ parentDetail }}</el-form-item>
        <el-form-item label="分类名称：" prop="categoryName">
          <el-input v-model="categoryVo.categoryName" ref="iptRef"></el-input>
        </el-form-item>
        <el-form-item label="目录类图：" v-if="categoryVo.level != 1">
          <el-upload :class="{ hide_uploadbtn: categoryVo.bannerUrl.length > 0 }" action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showAppImagePreview()"
            :on-remove="(e) => removeAppImage(e)" :file-list="categoryVo.bannerUrl" :http-request="(e) => uploadAppImage(e)" :multiple="false" :limit="1">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p v-if="categoryVo.level != 1" style="color: #999;line-height: 22px;">仅可上传一张图片,建议尺寸：480*270px</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkRepeat">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog :close-on-click-modal="false" title="编辑" :visible.sync="editDialog" width="30%">
      <el-form :model="basicInfo" :rules="rules" ref="edit">
        <el-form-item v-if="basicInfo.parentName" label="上级分类：">{{ basicInfo.parentName }}</el-form-item>
        <el-form-item label="分类名称:" prop="categoryName">
          <el-input v-model="basicInfo.categoryName" ref="iptRef"></el-input>
        </el-form-item>
        <el-form-item label="目录类图：" v-if="basicInfo.level != 1">
          <el-upload ref="elUpload" :class="{ hide_uploadbtn: basicInfo.bannerUrl.length > 0 }" action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showAppImagePreview()"
            :on-remove="(e) => removeAppImage(e, 'edit')" :file-list="basicInfo.bannerUrl" :http-request="(e) => uploadAppImage(e, 'edit')" :multiple="false" :limit="1">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p v-if="basicInfo.level != 1" style="color: #999;line-height: 22px;">仅可上传一张图片,建议尺寸：480*270px</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog :close-on-click-modal="false" title="删除" :visible.sync="deleteDialog" width="30%">
      <p>确认删除吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteDialog = false">取消</el-button>
        <el-button type="primary" @click="deleteCate()">确 定</el-button>
      </span>
    </el-dialog>
    <addProductDialog ref="addProductDialogRef"></addProductDialog>
  </div>
</template>
<script>
import uploadWebImg from '@/utils/uploadWebImg'
import VPagination from '@/components/Pagination/index.vue'
import { customCategoryUpdate, customCategoryList, customCategoryDelete, customCategoryUsable, customCategoryAdd, customCategoryQuerySubs, customCategorySetRecommend } from '@/api/pms'
import addProductDialog from './productList/index.vue'
export default {
  name: 'product-category',
  components: { addProductDialog },
  data () {
    return {
      deleteItem: '',
      deleteDialog: false,
      rules: {
        categoryName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      },
      editDialog: false,
      basicInfo: {
        categoryName: '',
        level: '',
        parentId: '',
        imageUrl: '',
        bannerUrl: []
      },
      parentDetail: {},
      addDialog: false,
      categoryVo: {
        categoryName: '',
        level: '',
        parentId: '',
        imageUrl: '',
        bannerUrl: []
      },
      tableData: [],
      queryInfo: {
        // type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      treeNodeObj: {},
      bannerForm: {
        type: '',
        associationId: '',
        associationName: '',
        bannerUrl: [],
        detailsUrl: []
      }
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    this.getCateList(this.queryInfo)
  },
  methods: {
    asd () {
    },
    showAppImagePreview (type) {
      console.log('showAppImagePreview')
      this.showImgPreview = true
      this.previewImage = this.bannerForm.bannerUrl
    },
    removeAppImage (val, type) {
      console.log('removeAppImage', val)
      let att = type === 'edit' ? 'basicInfo' : 'categoryVo'
      this[att].bannerUrl = []
    },
    checkImage (file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const img = new Image() // 创建一个Image对象
          const reader = new FileReader() // 创建一个FileReader对象

          reader.onload = function (e) {
            img.src = e.target.result // 设置Image对象的src属性为读取的结果
            img.onload = function () { // 图片加载完成后获取尺寸
              console.log('Width:', img.width) // 打印宽度
              console.log('Height:', img.height) // 打印高度
              if (img.width === 480 && img.height === 270) {
                resolve(true)
              } else {
                resolve(false)
              }
            }
          }

          reader.readAsDataURL(file) // 读取文件内容作为DataURL
        } else {
          resolve(false)
        }
      })
    },
    async uploadAppImage (e, type) {
      console.log(e, 'e - file')
      let checkImage = await this.checkImage(e.file)
      if (!checkImage) {
        this.$message.error('图片尺寸限制为480*270px')
        this.$refs.elUpload.clearFiles()
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          // this.categoryVo.bannerUrl.push({ url: res })
          let att = type === 'edit' ? 'basicInfo' : 'categoryVo'
          this[att].bannerUrl.push({ url: res })
        } else {
          this.$message.error('图片上传失败')
        }
      })
    },
    deleteCate () {
      customCategoryDelete(this.deleteItem.id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          if (this.treeNodeObj[this.deleteItem.parentId]) {
            this.$set(this.$refs.table.store.states.lazyTreeNodeMap, this.deleteItem.parentId, [])
            this.load(this.treeNodeObj[this.deleteItem.parentId].tree, '', this.treeNodeObj[this.deleteItem.parentId].resolve)
          }
          this.deleteDialog = false
        }
      })
    },
    saveEdit () {
      console.log(this.basicInfo, 'this.basicInfo')
      this.$refs.edit.validate((valid) => {
        if (valid) {
          customCategoryUsable({ act: 1, categoryName: this.basicInfo.categoryName, parentId: this.basicInfo.parentId, categoryId: this.basicInfo.id }).then((res) => {
            if (res.data.code === -1) {
              this.$message({
                type: 'error',
                message: '产品类重复'
              })
              this.$refs.iptRef.focus()
            } else if (res.data.success) {
              const _this = this
              let obj = {
                categoryId: this.basicInfo.id,
                categoryVo: {
                  // bannerUrl: this.basicInfo.bannerUrl[0]?.url || '',
                  categoryName: this.basicInfo.categoryName,
                  imageUrl: this.basicInfo.bannerUrl[0]?.url || '',
                  level: this.basicInfo.level,
                  parentId: this.basicInfo.parentId
                }
              }
              customCategoryUpdate(obj).then((res) => {
                if (res.data.success) {
                  this.getCateList(this.queryInfo)
                  this.$message.success('编辑分类成功')
                  this.editDialog = false
                  if (this.treeNodeObj[this.basicInfo.parentId]) {
                    this.$set(this.$refs.table.store.states.lazyTreeNodeMap, this.basicInfo.parentId, [])
                    this.load(this.treeNodeObj[this.basicInfo.parentId].tree, '', this.treeNodeObj[this.basicInfo.parentId].resolve)
                  }
                }
              })
            }
          })
        }
      })
    },
    onEditClassification (data) {
      let basicInfo = JSON.parse(JSON.stringify(data))
      if (basicInfo.imageUrl) {
        basicInfo.bannerUrl = [{ url: basicInfo.imageUrl }]
      } else {
        basicInfo.bannerUrl = []
      }
      this.basicInfo = basicInfo
      this.editDialog = true
      console.log(this.basicInfo, 'this.basicInfo')
    },
    onSubmit () {
      console.log(this.categoryVo, 'this.categoryVo')
      let obj = {
        // bannerUrl: this.categoryVo.bannerUrl[0]?.url || '',
        categoryName: this.categoryVo.categoryName,
        imageUrl: this.categoryVo.bannerUrl[0]?.url || '',
        level: this.categoryVo.level,
        parentId: this.categoryVo.parentId || 0
      }
      customCategoryAdd(obj).then((res) => {
        if (res.data.success) {
          this.parentDetail = ''
          this.categoryVo.categoryName = ''
          this.$message.success('添加产品类成功')
          this.addDialog = false
          this.removeAppImage()
          if (this.treeNodeObj[this.categoryVo.parentId]) {
            this.load(this.treeNodeObj[this.categoryVo.parentId].tree, '', this.treeNodeObj[this.categoryVo.parentId].resolve)
          } else {
            // this.getCateList(this.queryInfo)
          }
        }
      })
    },
    // 检查重复
    checkRepeat () {
      console.log(this.categoryVo, 'categoryVo')
      this.$refs.add.validate((valid) => {
        if (valid) {
          customCategoryUsable({ act: 0, categoryName: this.categoryVo.categoryName, parentId: this.categoryVo.parentId }).then((res) => {
            if (res.data.success) {
              this.onSubmit()
            }
          })
        }
      })
    },
    load (tree, treeNode, resolve) {
      this.treeNodeObj[tree.id] = {
        tree,
        resolve
      }
      console.log(tree, 'tree')
      // 获取下级
      customCategoryQuerySubs(tree.id).then((res) => {
        if (res.data.success) {
          console.log(res.data.data, 'res.data.data')
          let list = res.data.data.map(v => {
            v.parentName = tree.categoryName
            return v
          })
          resolve(list)
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 获取分类列表
    getCateList (val) {
      let _this = this
      customCategoryList({ pageNum: val.pageNum, pageSize: val.pageSize }).then((res) => {
        if (res.data.success) {
          let newList = res.data.data
          this.queryInfo.total = res.data.data.length
          this.tableData = newList
        }
      })
    },
    addSecondCategory (val) {
      let newList = {
        name: val.name,
        code: '564313',
        id: '222'
      }
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].id === val.id) {
          this.tableData[i].children.push(newList)
        }
      }
    },
    changePage (val) {
      this.queryInfo = val
      this.getCateList(this.queryInfo)
    },
    deleteTheme () {
      this.getCateList(this.queryInfo)
    },

    customCategorySetRecommend (item) {
      customCategorySetRecommend(item.id).then(res => {
        if (res.data.success) {
          this.$message.success('设置成功')
          customCategoryQuerySubs(item.parentId).then(res => {
            if (res.data.success) {
              this.$set(this.$refs.table.store.states.lazyTreeNodeMap, item.parentId, [])
              this.load(this.treeNodeObj[item.parentId].tree, '', this.treeNodeObj[item.parentId].resolve)
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "./styles";
@deep: ~">>>";
</style>
